import { endOfDay, parseISO, startOfDay } from 'date-fns';
import { isConfirmedStaffing } from './staffing.js';

export const recordId = (value) => String(value?.id || value?._id || value || '');
export function belongsToUser(record, user) {
  const id = recordId(user);
  return Boolean(id && recordId(record.user_id) === id) || Boolean(
    user?.email && (record.staff_email || record.user_email)?.toLowerCase() === user.email.toLowerCase()
  );
}
export function confirmedEventsForUser(events, staffings, user) {
  const ids = new Set(staffings.filter(s => belongsToUser(s, user) && isConfirmedStaffing(s)).map(s => recordId(s.event_id)));
  return events.filter(e => ids.has(recordId(e)) && !['archived', 'completed', 'cancelled'].includes(e.status));
}

// Personal staffing dates take precedence over the event's wider operational window.
export function selectCurrentEvent(events, staffings, user, now = new Date()) {
  const personal = staffings.filter(s => belongsToUser(s, user) && isConfirmedStaffing(s));
  const candidates = confirmedEventsForUser(events, personal, user).flatMap(event => {
    const staffing = personal.find(s => recordId(s.event_id) === recordId(event));
    const start = startOfDay(parseISO(staffing.staffing_start_date || event.start_date || ''));
    const end = endOfDay(parseISO(staffing.staffing_end_date || event.end_date || event.start_date || ''));
    return Number.isNaN(+start) || Number.isNaN(+end) || end < start ? [] : [{ event, start, end }];
  });
  // Finish the nearer assignment first when two operational windows overlap.
  const current = candidates.filter(e => e.start <= now && e.end >= now)
    .sort((a, b) => a.end - b.end || a.start - b.start || recordId(a.event).localeCompare(recordId(b.event)))[0];
  if (current) return { event: current.event, type: 'current' };
  const next = candidates.filter(e => e.start > now).sort((a, b) => a.start - b.start || a.end - b.end)[0];
  return next ? { event: next.event, type: 'next' } : { event: null, type: 'none' };
}
